module.exports = __webpack_public_path__ + "static/img/icon03.52314100.png";